// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"c8475e37","790":"c8475e37"}[chunkId] + ".chunk.css";
};